const config = {
    apiBaseUrl: 'https://medicore.demopod.in'
};

export default config;